




















































import {
  Vue,
  Component,
  Watch,
} from "@/shared/vuepack";
  import moment from "moment";
  import { formatCurrency } from "@/shared/currency";
  import { Permission } from "@/shared/types";
  import * as routes from "@/employer/route-names";
import { useEmployerPayrollStore } from "@/employer/store/employerPayroll";
import { usePayrollDashboardStore } from "@/employer/store/payrollDashboard";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { useUserStore } from "@/shared/store/user";

@Component
  export default class ContributionsWidget extends Vue {
    employerPayrollStore = useEmployerPayrollStore();
    payrollDashboardStore = usePayrollDashboardStore();
    rolePermissionStore = useRolePermissionsStore();
    userStore = useUserStore();
    routes = routes;
    formatCurrency = formatCurrency;

    mounted () {
      this.onEmployerIdChange();
    }
    @Watch("userStore.employerId")
    onEmployerIdChange () {
      this.payrollDashboardStore.initPayrollContributionsGraph();
      this.employerPayrollStore.getContributionsList(
        1,
        10
      );
    }

    get displayContributionsLink (): boolean {
      return this.rolePermissionStore.userHasPermission(Permission.PayrollRead);
    }

    get noContributionsChange (): boolean {
      return this.payrollDashboardStore.summedContributionsTotalChange === 0;
    }

    get isPositiveContributionChange (): boolean {
      return this.payrollDashboardStore.summedContributionsTotalChange > 0;
    }

    get isNegativeContributionChange (): boolean {
      return this.payrollDashboardStore.summedContributionsTotalChange < 0;
    }

    get employerContributionChangeCopy () {
      return this.payrollDashboardStore.employerContributionsTotalChange < 0 ? "decrease" : "increase";
    }

    get employeeContributionChangeCopy () {
      return this.payrollDashboardStore.employeeContributionsTotalChange < 0 ? "decrease" : "increase";
    }

    get formattedPayrollDate () {
      return moment(this.employerPayrollStore.payrollDate).format("MMM DD, YYYY");
    }

    get isLoaded () {
      return this.payrollDashboardStore.isPayrollContributionsGraphLoading === false;
    }
  }
